import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CentralClientePacotesClienteComponent } from './central-cliente-pacotes-cliente.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: CentralClientePacotesClienteComponent}
  ])],
  exports: [RouterModule]
})
export class CentralClientePacotesClienteRoutingModule { }
